/**
 * AuditDaySeparator — a horizontal label ("Heute" / "Gestern" / absolute date)
 * rendered between timeline day-groups. Hairlines on both sides flank the
 * typographic label; transparent background so the app's particle
 * back­drop stays visible behind it.
 */
interface AuditDaySeparatorProps {
  label: string;
}

export function AuditDaySeparator({ label }: AuditDaySeparatorProps) {
  return (
    <div className="flex items-center gap-3 py-3 select-none" role="separator" aria-label={label}>
      <span className="h-px flex-1 bg-white/6" />
      <span className="text-[10px] font-medium uppercase tracking-widest text-white/40">
        {label}
      </span>
      <span className="h-px flex-1 bg-white/6" />
    </div>
  );
}
